"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var findReadWriteRecipient_1 = require("./findReadWriteRecipient");
var resolveQueryStringToRecipient_1 = require("./resolveQueryStringToRecipient");
var setForceResolveState_1 = require("./setForceResolveState");
var showHideFindResult_1 = require("./showHideFindResult");
var owa_analytics_1 = require("owa-analytics");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('resolveAllUnresolvedRecipients')(function resolveAllUnresolvedRecipients(recipientWell, onBeforeWaitingResove) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var indexToRemove, i, persona, invalidRecipientDisplayText;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setForceResolveState_1.default(recipientWell, true);
                    // Trim the query string prior to resolving in case of just empty spaces in the send scenario.
                    recipientWell.queryString = recipientWell.queryString.trim();
                    if (!recipientWell.queryString) return [3 /*break*/, 2];
                    onBeforeWaitingResove && onBeforeWaitingResove();
                    return [4 /*yield*/, resolveQueryStringToRecipient_1.default(recipientWell, false /* shouldDirectlyResolve */, true /* searchDirectory */, true /* resolveIfSingle */)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 2:
                    indexToRemove = -1;
                    for (i = 0; i < recipientWell.recipients.length; i++) {
                        if (recipientWell.recipients[i].persona &&
                            recipientWell.recipients[i].persona.EmailAddress &&
                            !recipientWell.recipients[i].persona.EmailAddress.EmailAddress) {
                            persona = recipientWell.recipients[i].persona;
                            // Don't log the known single type of mailbox that doesn't have an email address
                            if (persona.EmailAddress.MailboxType != 'PrivateDL') {
                                // There are server errors that report of empty email addresses.
                                // However, we're not sure how users are adding things to the well without email addresses.
                                // This should help us identify what the mailbox type and routing type are for those specific entries
                                // We can then understand what we're handling incorrectly client side for those recipient types
                                // We're logging every instance (bypassing with doNotSample = true) because this is low volume and temporary
                                owa_analytics_1.logUsage('EmptyEmailAddress', [persona.EmailAddress.MailboxType, persona.EmailAddress.RoutingType], null, { doNotSample: true });
                            }
                        }
                        if (!recipientWell.recipients[i].isValid) {
                            indexToRemove = i;
                            break;
                        }
                    }
                    if (!(indexToRemove != -1)) return [3 /*break*/, 4];
                    invalidRecipientDisplayText = recipientWell.recipients[indexToRemove].displayText;
                    // Set the flag so we come back here after we add a recipient to the well
                    recipientWell.queryString = invalidRecipientDisplayText;
                    recipientWell.recipients.splice(indexToRemove, 1);
                    onBeforeWaitingResove && onBeforeWaitingResove();
                    return [4 /*yield*/, findReadWriteRecipient_1.default(recipientWell, invalidRecipientDisplayText, true /* searchDirectory */, true /* resolveIfSingle */)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    // This is the base case for the recursion
                    setForceResolveState_1.default(recipientWell, false);
                    showHideFindResult_1.default(recipientWell, false /* shouldShowFindResult */);
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=resolveAllUnresolvedRecipients.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/resolveAllUnresolvedRecipients.js
// module id = 2688
// module chunks = 2 3 4 45